import { useMutation } from '@tanstack/react-query';
import { exportAccommodationListToExcel } from '../api/accommodation.api';
import { toast } from '@/hooks/use-toast';

export const useAccommodationListExport = () => {
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await exportAccommodationListToExcel();
      return response;
    },
    onSuccess: (response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const disposition: string = response.headers['content-disposition'] ?? '';
      const match = disposition.match(/filename="([^"]+)"/);
      link.download = match ? decodeURIComponent(match[1]) : 'Tarifario Hotelero.xlsx';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast({
        title: "Descarga completada",
        description: "El tarifario se ha descargado exitosamente.",
        variant: "default",
      });
    },
    onError: (error: unknown) => {
      console.error("Error al exportar tarifario:", error);
      const axiosError = error as { response?: { data?: { message?: string } } };
      toast({
        title: "Error al exportar",
        description: axiosError?.response?.data?.message || "Ocurrió un error al generar el tarifario.",
        variant: "destructive",
      });
    },
  });

  return {
    exportList: mutation.mutate,
    isExporting: mutation.isPending,
  };
};
